import TimeFrameEnum from './modules/TimeFrameEnum';

export default {
  TimeFrameEnum,
};
